export default __webpack_public_path__ + "static/media/i48.fba15f8d.svg";